import { Component, Input } from '@angular/core';
import { IgnoredTimesheetsDataComponent } from '../ignored-timesheets-data/ignored-timesheets-data.component';
import { IgnoredTimesheetsSummaryComponent } from '../ignored-timesheets-summary/ignored-timesheets-summary.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ppl-ignored-timesheets',
  standalone: true,
  imports: [
    IgnoredTimesheetsDataComponent,
    IgnoredTimesheetsSummaryComponent,
    CommonModule,
  ],
  templateUrl: './ignored-timesheets.component.html',
  styleUrl: './ignored-timesheets.component.css',
})
export class IgnoredTimesheetsComponent {
  showSummary = true;
  sections = ['Summary', 'Details'];
  selectedSection = 'Summary';
  @Input() ignoredTimesheetData: any;
  @Input() ignoredTimesheetSummaryData: any;
  @Input() selectedBatchId: any;

  onSectionSelection(item: string) {
    this.selectedSection = item;
    if (item === 'Details') {
      this.showSummary = false;
    } else {
      this.showSummary = true;
    }
  }
}
